// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 视频换脸节点样式 */
.VideoFaceSwapNode-container {
  position: relative;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #d946ef 100%);
  border-radius: 16px;
  padding: 20px;
  min-width: 380px;
  max-width: 420px;
  box-shadow: 0 8px 32px rgba(99, 102, 241, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1) inset;
  color: #fff;
  transition: all 0.3s ease;
}

.VideoFaceSwapNode-container:hover {
  box-shadow: 0 12px 40px rgba(99, 102, 241, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.2) inset;
  transform: translateY(-2px);
}

.VideoFaceSwapNode-duplicate-button {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.3s ease;
  z-index: 10;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.VideoFaceSwapNode-duplicate-button:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.VideoFaceSwapNode-duplicate-button:active {
  transform: scale(0.95);
}

/* Handle 样式 */
.VideoFaceSwapNode-handle {
  width: 16px;
  height: 16px;
  background: white;
  border: 3px solid #6366f1;
  border-radius: 50%;
  position: absolute;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.VideoFaceSwapNode-handle:hover {
  width: 20px;
  height: 20px;
  border-width: 3px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.VideoFaceSwapNode-handle-face {
  border-color: #ec4899;
  background: linear-gradient(135deg, #ec4899 0%, #f472b6 100%);
}

.VideoFaceSwapNode-handle-video {
  border-color: #3b82f6;
  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
}

.VideoFaceSwapNode-handle-output {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border-color: #fff;
}

.VideoFaceSwapNode-handle-label {
  position: absolute;
  left: -70px;
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.025em;
  z-index: 100;
}

.VideoFaceSwapNode-handle:hover .VideoFaceSwapNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.35);
}

.VideoFaceSwapNode-handle:hover .VideoFaceSwapNode-handle-label::before {
  content: '';
  position: absolute;
  right: -4px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid #6366f1;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  filter: drop-shadow(0 1px 2px rgba(99, 102, 241, 0.2));
}

.VideoFaceSwapNode-handle-video .VideoFaceSwapNode-handle-label {
  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
}

.VideoFaceSwapNode-handle-video:hover .VideoFaceSwapNode-handle-label {
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.35);
}

.VideoFaceSwapNode-handle-video:hover .VideoFaceSwapNode-handle-label::before {
  border-left-color: #3b82f6;
  filter: drop-shadow(0 1px 2px rgba(59, 130, 246, 0.2));
}

.VideoFaceSwapNode-handle-face .VideoFaceSwapNode-handle-label {
  background: linear-gradient(135deg, #48bb78 0%, #2d7a5f 100%);
  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.25);
}

.VideoFaceSwapNode-handle-face:hover .VideoFaceSwapNode-handle-label {
  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);
}

.VideoFaceSwapNode-handle-face:hover .VideoFaceSwapNode-handle-label::before {
  border-left-color: #48bb78;
  filter: drop-shadow(0 1px 2px rgba(72, 187, 120, 0.2));
}

/* 节点被选中时，一直显示标签 */
.react-flow__node.selected .VideoFaceSwapNode-handle .VideoFaceSwapNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.35);
}

.react-flow__node.selected .VideoFaceSwapNode-handle-video .VideoFaceSwapNode-handle-label {
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.35);
}

.react-flow__node.selected .VideoFaceSwapNode-handle-face .VideoFaceSwapNode-handle-label {
  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);
}

/* 标签出现动画 */
@keyframes VideoFaceSwapNode-labelFadeIn {
  0% {
    opacity: 0;
    transform: translateY(-50%) translateX(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(-50%) translateX(-2px);
  }
}

.VideoFaceSwapNode-handle:hover .VideoFaceSwapNode-handle-label,
.react-flow__node.selected .VideoFaceSwapNode-handle .VideoFaceSwapNode-handle-label {
  animation: VideoFaceSwapNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 可点击的 Handle 标签 */
.VideoFaceSwapNode-handle-label-clickable {
  pointer-events: auto;  /* 改为可交互 */
  cursor: pointer;       /* 显示手型光标 */
  user-select: none;     /* 禁止文本选择 */
}

/* 可点击标签的悬停效果 */
.VideoFaceSwapNode-handle-label-clickable:hover {
  transform: translateY(-50%) translateX(-4px) scale(1.05);
  box-shadow: 0 8px 24px rgba(99, 102, 241, 0.45);
}

.VideoFaceSwapNode-handle-video .VideoFaceSwapNode-handle-label-clickable:hover {
  box-shadow: 0 8px 24px rgba(59, 130, 246, 0.45);
}

.VideoFaceSwapNode-handle-face .VideoFaceSwapNode-handle-label-clickable:hover {
  box-shadow: 0 8px 24px rgba(72, 187, 120, 0.45);
}

/* 可点击标签的按下效果 */
.VideoFaceSwapNode-handle-label-clickable:active {
  transform: translateY(-50%) translateX(-2px) scale(0.98);
}

/* 添加点击提示图标 */
.VideoFaceSwapNode-handle-label-clickable::after {
  content: ' +';
  font-weight: 700;
  margin-left: 4px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.VideoFaceSwapNode-handle-label-clickable:hover::after {
  opacity: 1;
}

/* 标题 */
.VideoFaceSwapNode-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 16px;
  text-align: center;
  color: #fff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.VideoFaceSwapNode-title::before {
  content: '🎭';
  font-size: 20px;
}

/* 包装器 */
.VideoFaceSwapNode-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 字段 */
.VideoFaceSwapNode-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: rgba(255, 255, 255, 0.08);
  padding: 12px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  transition: all 0.3s ease;
}

.VideoFaceSwapNode-field:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.25);
}

.VideoFaceSwapNode-label {
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  gap: 6px;
}

.VideoFaceSwapNode-label::before {
  content: '';
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: currentColor;
}

/* 图片预览 */
.VideoFaceSwapNode-image-preview {
  width: 80px;
  height: 80px;
  border-radius: 10px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  position: relative;
  flex-shrink: 0;
}

.VideoFaceSwapNode-image-preview::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.1) 100%);
  pointer-events: none;
}

.VideoFaceSwapNode-preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.VideoFaceSwapNode-image-preview:hover .VideoFaceSwapNode-preview-img {
  transform: scale(1.05);
}

/* 视频预览 */
.VideoFaceSwapNode-video-preview {
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  position: relative;
}

.VideoFaceSwapNode-video-preview::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.1) 100%);
  pointer-events: none;
}

.VideoFaceSwapNode-preview-video {
  width: 100%;
  max-height: 220px;
  display: block;
  object-fit: cover;
}

/* 占位符 */
.VideoFaceSwapNode-placeholder {
  background: rgba(255, 255, 255, 0.05);
  border: 2px dashed rgba(255, 255, 255, 0.25);
  border-radius: 10px;
  padding: 16px 12px;
  text-align: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  cursor: pointer;
}

.VideoFaceSwapNode-placeholder:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.4);
}

/* 人脸字段占位符 - 更小的尺寸 */
.VideoFaceSwapNode-field:first-of-type .VideoFaceSwapNode-placeholder {
  min-height: 80px;
  font-size: 11px;
  padding: 12px 10px;
}

/* 提示 */
.VideoFaceSwapNode-hint {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  border-radius: 10px;
  padding: 14px 16px;
  font-size: 12px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(5px);
}

.VideoFaceSwapNode-hint strong {
  color: #fff;
  font-weight: 600;
}

/* 按钮容器 */
.VideoFaceSwapNode-actions {
  margin-top: 8px;
}

/* 生成按钮 */
.VideoFaceSwapNode-generate {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  color: #6366f1;
  border: none;
  border-radius: 12px;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 
    0 4px 20px rgba(99, 102, 241, 0.25),
    0 0 0 1px rgba(255, 255, 255, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
  position: relative;
  overflow: hidden;
  letter-spacing: 0.5px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* 按钮图标 */
.VideoFaceSwapNode-generate::after {
  content: '✨';
  font-size: 18px;
  transition: transform 0.3s ease;
}

/* 光泽效果 */
.VideoFaceSwapNode-generate::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg, 
    transparent, 
    rgba(99, 102, 241, 0.15), 
    transparent
  );
  transition: left 0.6s ease;
}

.VideoFaceSwapNode-generate:hover:not(:disabled) {
  transform: translateY(-3px) scale(1.02);
  box-shadow: 
    0 8px 30px rgba(99, 102, 241, 0.4),
    0 0 0 1px rgba(255, 255, 255, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  background: linear-gradient(135deg, #ffffff 0%, #ffffff 100%);
}

.VideoFaceSwapNode-generate:hover:not(:disabled)::before {
  left: 100%;
}

.VideoFaceSwapNode-generate:hover:not(:disabled)::after {
  transform: rotate(15deg) scale(1.2);
}

.VideoFaceSwapNode-generate:active:not(:disabled) {
  transform: translateY(-1px) scale(0.98);
  box-shadow: 
    0 4px 15px rgba(99, 102, 241, 0.3),
    0 0 0 1px rgba(255, 255, 255, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.4);
}

.VideoFaceSwapNode-generate-disabled {
  background: rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.4);
  cursor: not-allowed;
  opacity: 0.6;
  box-shadow: none;
}

.VideoFaceSwapNode-generate-disabled::after {
  content: '⏳';
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 错误提示 */
.VideoFaceSwapNode-error {
  background: linear-gradient(135deg, rgba(255, 59, 48, 0.9) 0%, rgba(239, 68, 68, 0.9) 100%);
  color: #fff;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 13px;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 12px rgba(255, 59, 48, 0.3);
  font-weight: 500;
  animation: shake 0.5s ease-in-out;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  75% { transform: translateX(5px); }
}

`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/VideoFaceSwapNode.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,kBAAkB;EAClB,0EAA0E;EAC1E,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,wFAAwF;EACxF,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yFAAyF;EACzF,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,qCAAqC;EACrC,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,iDAAiD;EACjD,+CAA+C;EAC/C,0CAA0C;EAC1C,0BAA0B;EAC1B,yCAAyC;EACzC,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;EACpC,sDAAsD;AACxD;;AAEA;EACE,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA;EACE,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,WAAW;AACX;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,4CAA4C;EAC9C;AACF;;AAEA;;EAEE,0EAA0E;AAC5E;;AAEA,mBAAmB;AACnB;EACE,oBAAoB,GAAG,UAAU;EACjC,eAAe,QAAQ,WAAW;EAClC,iBAAiB,MAAM,WAAW;AACpC;;AAEA,eAAe;AACf;EACE,wDAAwD;EACxD,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,eAAe;AACf;EACE,wDAAwD;AAC1D;;AAEA,aAAa;AACb;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,OAAO;AACP;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,OAAO;AACP;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,SAAS;AACT;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,0CAA0C;EAC1C,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,4EAA4E;EAC5E,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,0CAA0C;EAC1C,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,4EAA4E;EAC5E,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA,QAAQ;AACR;EACE,qCAAqC;EACrC,4CAA4C;EAC5C,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA,OAAO;AACP;EACE,gGAAgG;EAChG,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD;;;0CAGwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,SAAS;AACT;EACE,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC;;AAEA,SAAS;AACT;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC;;;0CAGwC;EACxC,6DAA6D;AAC/D;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC;;;0CAGwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,SAAS;AACT;EACE,2FAA2F;EAC3F,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,0CAA0C;EAC1C,6CAA6C;EAC7C,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC","sourcesContent":["/* 视频换脸节点样式 */\n.VideoFaceSwapNode-container {\n  position: relative;\n  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #d946ef 100%);\n  border-radius: 16px;\n  padding: 20px;\n  min-width: 380px;\n  max-width: 420px;\n  box-shadow: 0 8px 32px rgba(99, 102, 241, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1) inset;\n  color: #fff;\n  transition: all 0.3s ease;\n}\n\n.VideoFaceSwapNode-container:hover {\n  box-shadow: 0 12px 40px rgba(99, 102, 241, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.2) inset;\n  transform: translateY(-2px);\n}\n\n.VideoFaceSwapNode-duplicate-button {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: rgba(255, 255, 255, 0.15);\n  color: #fff;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  z-index: 10;\n  backdrop-filter: blur(5px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.VideoFaceSwapNode-duplicate-button:hover {\n  background: rgba(255, 255, 255, 0.25);\n  transform: scale(1.1);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.VideoFaceSwapNode-duplicate-button:active {\n  transform: scale(0.95);\n}\n\n/* Handle 样式 */\n.VideoFaceSwapNode-handle {\n  width: 16px;\n  height: 16px;\n  background: white;\n  border: 3px solid #6366f1;\n  border-radius: 50%;\n  position: absolute;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.VideoFaceSwapNode-handle:hover {\n  width: 20px;\n  height: 20px;\n  border-width: 3px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.VideoFaceSwapNode-handle-face {\n  border-color: #ec4899;\n  background: linear-gradient(135deg, #ec4899 0%, #f472b6 100%);\n}\n\n.VideoFaceSwapNode-handle-video {\n  border-color: #3b82f6;\n  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);\n}\n\n.VideoFaceSwapNode-handle-output {\n  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);\n  border-color: #fff;\n}\n\n.VideoFaceSwapNode-handle-label {\n  position: absolute;\n  left: -70px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(8px);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  letter-spacing: 0.025em;\n  z-index: 100;\n}\n\n.VideoFaceSwapNode-handle:hover .VideoFaceSwapNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.35);\n}\n\n.VideoFaceSwapNode-handle:hover .VideoFaceSwapNode-handle-label::before {\n  content: '';\n  position: absolute;\n  right: -4px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-left: 4px solid #6366f1;\n  border-top: 4px solid transparent;\n  border-bottom: 4px solid transparent;\n  filter: drop-shadow(0 1px 2px rgba(99, 102, 241, 0.2));\n}\n\n.VideoFaceSwapNode-handle-video .VideoFaceSwapNode-handle-label {\n  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);\n}\n\n.VideoFaceSwapNode-handle-video:hover .VideoFaceSwapNode-handle-label {\n  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.35);\n}\n\n.VideoFaceSwapNode-handle-video:hover .VideoFaceSwapNode-handle-label::before {\n  border-left-color: #3b82f6;\n  filter: drop-shadow(0 1px 2px rgba(59, 130, 246, 0.2));\n}\n\n.VideoFaceSwapNode-handle-face .VideoFaceSwapNode-handle-label {\n  background: linear-gradient(135deg, #48bb78 0%, #2d7a5f 100%);\n  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.25);\n}\n\n.VideoFaceSwapNode-handle-face:hover .VideoFaceSwapNode-handle-label {\n  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);\n}\n\n.VideoFaceSwapNode-handle-face:hover .VideoFaceSwapNode-handle-label::before {\n  border-left-color: #48bb78;\n  filter: drop-shadow(0 1px 2px rgba(72, 187, 120, 0.2));\n}\n\n/* 节点被选中时，一直显示标签 */\n.react-flow__node.selected .VideoFaceSwapNode-handle .VideoFaceSwapNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.35);\n}\n\n.react-flow__node.selected .VideoFaceSwapNode-handle-video .VideoFaceSwapNode-handle-label {\n  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.35);\n}\n\n.react-flow__node.selected .VideoFaceSwapNode-handle-face .VideoFaceSwapNode-handle-label {\n  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);\n}\n\n/* 标签出现动画 */\n@keyframes VideoFaceSwapNode-labelFadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(-50%) translateX(-10px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(-50%) translateX(-2px);\n  }\n}\n\n.VideoFaceSwapNode-handle:hover .VideoFaceSwapNode-handle-label,\n.react-flow__node.selected .VideoFaceSwapNode-handle .VideoFaceSwapNode-handle-label {\n  animation: VideoFaceSwapNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* 可点击的 Handle 标签 */\n.VideoFaceSwapNode-handle-label-clickable {\n  pointer-events: auto;  /* 改为可交互 */\n  cursor: pointer;       /* 显示手型光标 */\n  user-select: none;     /* 禁止文本选择 */\n}\n\n/* 可点击标签的悬停效果 */\n.VideoFaceSwapNode-handle-label-clickable:hover {\n  transform: translateY(-50%) translateX(-4px) scale(1.05);\n  box-shadow: 0 8px 24px rgba(99, 102, 241, 0.45);\n}\n\n.VideoFaceSwapNode-handle-video .VideoFaceSwapNode-handle-label-clickable:hover {\n  box-shadow: 0 8px 24px rgba(59, 130, 246, 0.45);\n}\n\n.VideoFaceSwapNode-handle-face .VideoFaceSwapNode-handle-label-clickable:hover {\n  box-shadow: 0 8px 24px rgba(72, 187, 120, 0.45);\n}\n\n/* 可点击标签的按下效果 */\n.VideoFaceSwapNode-handle-label-clickable:active {\n  transform: translateY(-50%) translateX(-2px) scale(0.98);\n}\n\n/* 添加点击提示图标 */\n.VideoFaceSwapNode-handle-label-clickable::after {\n  content: ' +';\n  font-weight: 700;\n  margin-left: 4px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.VideoFaceSwapNode-handle-label-clickable:hover::after {\n  opacity: 1;\n}\n\n/* 标题 */\n.VideoFaceSwapNode-title {\n  font-size: 18px;\n  font-weight: 700;\n  margin-bottom: 16px;\n  text-align: center;\n  color: #fff;\n  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  letter-spacing: 0.5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.VideoFaceSwapNode-title::before {\n  content: '🎭';\n  font-size: 20px;\n}\n\n/* 包装器 */\n.VideoFaceSwapNode-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* 字段 */\n.VideoFaceSwapNode-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background: rgba(255, 255, 255, 0.08);\n  padding: 12px;\n  border-radius: 12px;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  transition: all 0.3s ease;\n}\n\n.VideoFaceSwapNode-field:hover {\n  background: rgba(255, 255, 255, 0.12);\n  border-color: rgba(255, 255, 255, 0.25);\n}\n\n.VideoFaceSwapNode-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 1);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.VideoFaceSwapNode-label::before {\n  content: '';\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n/* 图片预览 */\n.VideoFaceSwapNode-image-preview {\n  width: 80px;\n  height: 80px;\n  border-radius: 10px;\n  overflow: hidden;\n  background: rgba(0, 0, 0, 0.3);\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  position: relative;\n  flex-shrink: 0;\n}\n\n.VideoFaceSwapNode-image-preview::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.1) 100%);\n  pointer-events: none;\n}\n\n.VideoFaceSwapNode-preview-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  transition: transform 0.3s ease;\n}\n\n.VideoFaceSwapNode-image-preview:hover .VideoFaceSwapNode-preview-img {\n  transform: scale(1.05);\n}\n\n/* 视频预览 */\n.VideoFaceSwapNode-video-preview {\n  width: 100%;\n  border-radius: 10px;\n  overflow: hidden;\n  background: rgba(0, 0, 0, 0.3);\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n\n.VideoFaceSwapNode-video-preview::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.1) 100%);\n  pointer-events: none;\n}\n\n.VideoFaceSwapNode-preview-video {\n  width: 100%;\n  max-height: 220px;\n  display: block;\n  object-fit: cover;\n}\n\n/* 占位符 */\n.VideoFaceSwapNode-placeholder {\n  background: rgba(255, 255, 255, 0.05);\n  border: 2px dashed rgba(255, 255, 255, 0.25);\n  border-radius: 10px;\n  padding: 16px 12px;\n  text-align: center;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.85);\n  min-height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.VideoFaceSwapNode-placeholder:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n/* 人脸字段占位符 - 更小的尺寸 */\n.VideoFaceSwapNode-field:first-of-type .VideoFaceSwapNode-placeholder {\n  min-height: 80px;\n  font-size: 11px;\n  padding: 12px 10px;\n}\n\n/* 提示 */\n.VideoFaceSwapNode-hint {\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);\n  border-radius: 10px;\n  padding: 14px 16px;\n  font-size: 12px;\n  line-height: 1.8;\n  color: rgba(255, 255, 255, 0.9);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(5px);\n}\n\n.VideoFaceSwapNode-hint strong {\n  color: #fff;\n  font-weight: 600;\n}\n\n/* 按钮容器 */\n.VideoFaceSwapNode-actions {\n  margin-top: 8px;\n}\n\n/* 生成按钮 */\n.VideoFaceSwapNode-generate {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  color: #6366f1;\n  border: none;\n  border-radius: 12px;\n  padding: 16px 32px;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: \n    0 4px 20px rgba(99, 102, 241, 0.25),\n    0 0 0 1px rgba(255, 255, 255, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.6);\n  position: relative;\n  overflow: hidden;\n  letter-spacing: 0.5px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n/* 按钮图标 */\n.VideoFaceSwapNode-generate::after {\n  content: '✨';\n  font-size: 18px;\n  transition: transform 0.3s ease;\n}\n\n/* 光泽效果 */\n.VideoFaceSwapNode-generate::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg, \n    transparent, \n    rgba(99, 102, 241, 0.15), \n    transparent\n  );\n  transition: left 0.6s ease;\n}\n\n.VideoFaceSwapNode-generate:hover:not(:disabled) {\n  transform: translateY(-3px) scale(1.02);\n  box-shadow: \n    0 8px 30px rgba(99, 102, 241, 0.4),\n    0 0 0 1px rgba(255, 255, 255, 0.2),\n    inset 0 1px 0 rgba(255, 255, 255, 0.8);\n  background: linear-gradient(135deg, #ffffff 0%, #ffffff 100%);\n}\n\n.VideoFaceSwapNode-generate:hover:not(:disabled)::before {\n  left: 100%;\n}\n\n.VideoFaceSwapNode-generate:hover:not(:disabled)::after {\n  transform: rotate(15deg) scale(1.2);\n}\n\n.VideoFaceSwapNode-generate:active:not(:disabled) {\n  transform: translateY(-1px) scale(0.98);\n  box-shadow: \n    0 4px 15px rgba(99, 102, 241, 0.3),\n    0 0 0 1px rgba(255, 255, 255, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.4);\n}\n\n.VideoFaceSwapNode-generate-disabled {\n  background: rgba(255, 255, 255, 0.15);\n  color: rgba(255, 255, 255, 0.4);\n  cursor: not-allowed;\n  opacity: 0.6;\n  box-shadow: none;\n}\n\n.VideoFaceSwapNode-generate-disabled::after {\n  content: '⏳';\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* 错误提示 */\n.VideoFaceSwapNode-error {\n  background: linear-gradient(135deg, rgba(255, 59, 48, 0.9) 0%, rgba(239, 68, 68, 0.9) 100%);\n  color: #fff;\n  padding: 12px 16px;\n  border-radius: 10px;\n  font-size: 13px;\n  text-align: center;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 4px 12px rgba(255, 59, 48, 0.3);\n  font-weight: 500;\n  animation: shake 0.5s ease-in-out;\n}\n\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  25% { transform: translateX(-5px); }\n  75% { transform: translateX(5px); }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
